/**
 * Sucursales de aeropuerto que comparten ciudad con otra: la página se renderiza
 * por ciudad, así que varios códigos sirven el mismo contenido. Cada entrada
 * apunta al código canónico de su ciudad para declarar `rel=canonical`.
 */
export const AIRPORT_CANONICAL_CODE: Readonly<Record<number, number>> = {
    2: 1,
    3: 1,
    10: 9,
    13: 11,
    16: 15,
    17: 15,
    19: 18,
    30: 29,
    31: 29,
    42: 38,
    44: 38,
    53: 90,
    58: 59,
    60: 59,
    69: 63,
    76: 75,
    77: 124,
    78: 123,
    79: 123,
    80: 116,
    82: 38,
    84: 63,
    85: 73,
    94: 4,
    95: 177,
    96: 177,
    97: 177,
    105: 15,
    112: 108,
    114: 124,
    119: 38,
    120: 15,
    121: 15,
    125: 123,
    127: 38,
    130: 38,
    134: 38,
    135: 29,
    136: 1,
    138: 25,
    139: 118,
    140: 118,
    141: 126,
    142: 122,
    144: 4,
    145: 4,
    146: 4,
    147: 4,
    148: 4,
    149: 4,
    150: 4,
    151: 4,
    152: 4,
    154: 4,
    155: 90,
    156: 90,
    157: 90,
    158: 90,
    159: 90,
    160: 90,
    161: 90,
    162: 90,
    165: 38,
    166: 9,
    170: 133,
    171: 59,
    172: 61,
    173: 61,
    179: 75,
    185: 4,
    192: 46,
    248: 191,
};

export const resolveCanonicalAirportCode = (code: number): number =>
    AIRPORT_CANONICAL_CODE[code] ?? code;
